<script setup lang="ts">
import { suggestions, suggestions2 } from "~/utils/constants"

const globeSize = ref<number>(300)
const fullSuggestions = [...suggestions, ...suggestions2]
</script>

<template>
	<section
		id="features"
		class="scroll-m-t-9xl bg-[url(/website/feature-bg.svg)] bg-cover bg-top bg-no-repeat py-12">
		<div class="container">
			<LandingTitle class="mb-12">
				<template #title>
					توانمندی ها
				</template>

				<template #description>
					با اپلیکیشن بیشتر آشنا شو و ببین که چه کار هایی از دستش بر میاد !
				</template>
			</LandingTitle>

			<div class="grid gap-10">
				<div class="grid gap-10 lg:grid-cols-2">
					<PromtFeature
						:items="fullSuggestions" />

					<SupportedModelsFeature />
				</div>

				<div
					class="grid gap-10 lg:grid-cols-3 md:grid-cols-2">
					<WebSearchFeature />

					<PlatformsFeature
						:globe-size="globeSize" />

					<HistoryFeature />
				</div>
			</div>
		</div>
	</section>
</template>
